import { render, staticRenderFns } from "./SignalList.vue?vue&type=template&id=1b412b55&scoped=true&"
import script from "./SignalList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b412b55",
  null
  
)

export default component.exports